import { ChangeDetectionStrategy, Component, HostBinding, Inject, Optional, ViewEncapsulation } from "@angular/core";
import { Store } from "@ngrx/store";
import { CoreState, DocumentMetaAction, StatusCodeService } from "@obg/ngx.core";
import { ignoreNil, LocationService, StatusCodes } from "@obg/ngx.global";
import { RouteSelector } from "@obg/ngx.router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { CORE_UI_ERRORS_CONFIG } from "../const";
import { CoreUiErrorsConfig } from "../model";

import { InternalErrorConfigService } from "./internal-error.config";
import { InternalErrorParams } from "./internal-error.model";

// TODO: https://edgealpha.corpsson.com/browse/AOCC-12020
// Decouple this component from the CRS, because if the CRS
// is down itself, the text won't show up on this page.
// Originally posted here: https://github.com/BetssonGroup/core-obg-fe-adaptive-sites/pull/23784/files#r1365597361

@Component({
	templateUrl: "./internal-error.component.html",
	styleUrls: ["./internal-error.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class InternalErrorComponent {
	@HostBinding("class.obg-internal-error") hostCssClass = true;

	customerSupportUrl$: Observable<string | undefined> | undefined;

	readonly useAssetsPath: boolean;
	readonly isRefreshVisible: boolean;

	private readonly metaTitle = "500";

	constructor(
		private locationService: LocationService,
		store: Store<CoreState>,
		documentMetaAction: DocumentMetaAction,
		statusCodeService: StatusCodeService,
		config: InternalErrorConfigService,
		@Optional() @Inject(CORE_UI_ERRORS_CONFIG) coreUIErrorsConfig: CoreUiErrorsConfig | undefined
	) {
		this.useAssetsPath = coreUIErrorsConfig?.internalError?.useAssetsPath ?? false;
		statusCodeService.setStatusCode(StatusCodes.InternalServerError, "direct-navigation-to-500");
		store.dispatch(documentMetaAction.updateMetaTitle(this.metaTitle));
		this.customerSupportUrl$ = store.select<InternalErrorParams | undefined>(RouteSelector.getData).pipe(
			ignoreNil(),
			map((data) => (data.showMobileSupport ? config.getSupportLink().mobile : config.getSupportLink().desktop))
		);
		this.isRefreshVisible = !config.getHideRefresh();
	}

	refresh() {
		this.locationService.navigate("/");
	}
}
